module.exports = __webpack_public_path__ + "img/juice-concentrates.22810261.jpg";